<template>
<page :title="i18n.detail">
  <div class="coupon-warp" v-if="coupon">
    <div class="coupon-card">
      <!-- <img class="coupon-card-bg" src="../../assets/imgs/coupon_bg.png" mode=""/> -->
      <img class="coupon-card-bg" v-if="lang==='en-US'" src="../../assets/imgs/coupon_bg_en.png" mode=""/>
      <img class="coupon-card-bg" v-else src="../../assets/imgs/coupon_bg_zh.png" mode=""/>
      <div class="coupon-neibu">
        <div class="title">{{coupon.ruleName}}</div>
        <div class="coupon-item-foot">
          <div class="tips">{{i18n.deadline}}</div>
          <span>：</span>
          <div class="date" v-if="lang==='en-US'">{{coupon.pEnd.substring(0, 10)}}</div>
          <div class="date" v-else>{{coupon.pEnd.substring(0, 10)}}</div>
        </div>
      </div>
      <img v-if="coupon.ruleLogo" class="coupon-card-logo" :src="coupon.ruleLogo" mode=""/>
      <img v-else class="coupon-card-logo" src="../../assets/imgs/coupon_logo.png" mode=""/>
    </div>
    <div class="coupon-remark">
      <div v-if="coupon.pSm" v-html="coupon.pSm"></div>
      <template v-else>
        <div class="title">{{i18n.instructions}}</div>
        <div>{{i18n.tips1}}</div>
        <div>{{i18n.tips2}}</div>
        <div>{{i18n.tips3}}</div>
        <!-- <div class="title">{{i18n.restrict}}</div> -->
        <div>{{i18n.tips4}}</div>
        <div>{{i18n.tips5}}</div>
        <div>{{i18n.tips6}}</div>
      </template>
    </div>
    <!-- <div class="" v-html="test ? test : ''"></div> -->
  </div>
</page>
</template>

<script>
import { mapState } from 'vuex'
import page from '../../components/layouts/page.vue'

export default {
  components: { page },
  computed: {
    ...mapState(['coupon', 'lang']),
    i18n () {
      return this.$t('coupon')
    }
  }
  // onShow () {
  //   if (!this.coupon) {
  //     uni.redirectTo({
  //       url: '../coupon/coupon'
  //     })
  //   }
  // }
}
</script>

<style lang="less">
  .coupon-card {
    width: 700px;
    height: 202px;
    margin: 40px auto;
    position: relative;
    color: #FFFFFF;
    font-size: 28px;
    .coupon-card-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .coupon-neibu {
      z-index: 99;
      position: absolute;
      top: 18px;
      left: 66px;
      font-size: 24px;
      .title {
        font-size: 36px;
        font-weight: 600;
        // border-bottom: 2px solid #FFFFFF;
        line-height: 80px;
        margin-bottom: 6px;
      }
      .coupon-item-foot {
        display: flex;
        flex-direction: row;
        margin-top: 40px;
      }
    }
    .coupon-card-logo {
      position: absolute;
      z-index: 98;
      top: 50px;
      right: 20px;
      height: 100px;
      width: 100px;
      border-radius: 50%;
    }
  }
  .coupon-remark {
    width: 620px;
    margin: 0 auto;
    background-image: linear-gradient(#2cd6f9, #00a9e1);
    border-radius: 20px;
    color: #FFFFFF;
    font-size: 28px;
    line-height: 40px;
    padding: 30px 40px;
    .title {
      padding: 20px 0;
      font-size: 36px;
    }
  }
</style>
